// Central logo, single source of truth.
// Self-hosted and optimized (WebP, 600×275, ~14 KB) — was a 424 KB PNG loaded from an
// external asset host on every render. White Harris Homes LLC primary mark (owner-provided).
export const LOGO_PRIMARY = "/harris-homes-logo.webp";
export const LOGO_WIDTH = 600;
export const LOGO_HEIGHT = 275;

// Alternate gold variant — same file for now (the gold variant was unused)
export const LOGO_GOLD = "/harris-homes-logo.webp";
